import React from 'react';
// Import Global Components
import RegisterForm from '../RegisterForm';

function ResetPassword({ user, resetPassword, ...props }) {
  return <RegisterForm
    email={user.email}
    title="Reset Password"
    onClick={resetPassword}
    btnText="Reset"
    {...props}
  />;
}

export default ResetPassword;
